import { Link, Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { InstantTransferDescription } from 'shared/modules/superpay/instant-transfer/InstantTransferDescription';
import { SuperPayInstantTransferDialogDTO } from 'shared/modules/superpay/SuperPayDTO';
import styled from 'styled-components';

const BoxStyled = styled(Box)`
  flex-direction: column;
  gap: 24px;
`;

export function InstantTransferExpired({
  onClose,
  dialogInformation,
}: {
  onClose: () => void;
  dialogInformation: SuperPayInstantTransferDialogDTO;
}) {
  return (
    <BoxStyled
      padding="medium"
      height="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Stack space="medium">
        <Stack space="small">
          <Typography variant="h2">
            Instant Transfer No Longer Available
          </Typography>
          <Typography>
            The Instant Transfer offer for{' '}
            {isWebView ? (
              dialogInformation.load_id
            ) : (
              <Link
                underline="none"
                color="primary"
                href={`/tms/loads/${dialogInformation.load_guid}`}
              >
                {dialogInformation.load_id}
              </Link>
            )}{' '}
            has expired and is no longer available.
          </Typography>
        </Stack>
        <InstantTransferDescription />
      </Stack>
      <Button fullWidth={isWebView} onClick={onClose}>
        Got It
      </Button>
    </BoxStyled>
  );
}
